import { ADD_SERVICE, CHANGE_CLOUD, CHANGE_REGISTRY, CHANGE_SERVICES } from './constants';

const INIT_STATE = {
    cloudPlatform: null,
    services: [],
    registry: null,
};

const UserSettings = (state = INIT_STATE, action) => {
    switch (action.type) {
        case CHANGE_CLOUD:
            return { ...state, cloudPlatform: action.payload };
        case CHANGE_SERVICES:
            return { ...state, services: action.payload };
        case ADD_SERVICE:
            const services = state.services.map((service) => {
                if (service.id === action.payload.id) {
                    return action.payload;
                } else {
                    return service;
                }
            });
            if (services.includes(action.payload)) {
                return { ...state, services: [...services] };
            } else {
                return { ...state, services: [...services, action.payload] };
            }
        case CHANGE_REGISTRY:
            return { ...state, registry: action.payload };
        default:
            return state;
    }
};

export default UserSettings;
